exports = module.exports = require("../../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-overlay__loader,.video-overlay__play{position:absolute;top:0;left:0;right:0;bottom:0}.video-overlay__loader .video-spinner,.video-overlay__play .video-icon{position:absolute;top:50%;left:50%;height:70px;width:80px;margin-left:-40px;margin-top:-35px;font-size:30px;border-radius:10px;padding:20px;background-color:rgba(0,0,0,.7);box-sizing:border-box}.video-overlay__play{cursor:pointer}.video-overlay__error{position:absolute;top:50%;left:0;right:0;padding:0 40px;transform:translateY(-50%);text-align:center;color:#fff;font-size:13px}.video-overlay__error-text{display:inline;padding:10px 20px;background-color:rgba(0,0,0,.7)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-html5video/src/components/video/overlay/overlay.css
// module id = 1380
// module chunks = 0